import { GiftcardService } from '@/api/giftcard'
import { Button } from '@/cn/ui/button'
import { popup } from '@/popup_handler'
import { TitleBar } from '@/ui/titlebar'
import { localizeFiat } from '@/utils'
import { useMutation } from '@tanstack/react-query'
import { CircleCheckBig } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

const GiftCardClaim = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [code, setCode] = useState('')
  useEffect(() => {
    setCode(location?.state?.giftCardCode)
  }, [])
  const mutation = useMutation(async () => GiftcardService.Claim(code), {
    onError: (error: any) => {
      popup.open('error', {
        description: String(error.message || error),
      })
    },
    onSuccess: (data) => {
      navigate('../')
      popup.open('information', {
        icon: CircleCheckBig,
        iconClass: 'text-green-500',
        title: 'Hurrah!',
        description: (
          <>
            <span>
              {data.result.senderUser.name} sent you a gift card 🎁 of {localizeFiat(data.result.amount)} & you've claimed it.
            </span>
            <br />
            <span>Time to spend that crypto & vibe 🎉</span>
            <br />
            <span>Your balance has been updated, check now!</span>
          </>
        ),
      })
    },
  }) as any

  return (
    <div className="flex flex-col gap-6 p-4 text-foreground w-full h-full">
      <TitleBar title="Claim Gift Card" />
      <div className="h-full w-full flex flex-col gap-4">
        <h5 className="text-left">Enter your gift code</h5>
        <label className="w-full flex items-center justify-center">
          <input
            type="text"
            inputMode="decimal"
            onChange={(e) => {
              setCode(e.target.value)
            }}
            value={code}
            className="  outline-none border-b-2 w-full border-gray-200 focus:border-primary"
            placeholder="Enter Gift Card Code"
            autoFocus
          />
        </label>
        <Button loading={mutation.isLoading} onClick={() => mutation.mutate()}>
          Claim
        </Button>
      </div>
    </div>
  )
}
export default GiftCardClaim
